module.exports = __webpack_public_path__ + "media/images/pic/brodno/polygon_news_smaller-96dc9425e22553c3a011cd3b8c91e497.png";